export default "__VITE_ASSET__hWnHfjPB__"